<template>
  <div class="plugin-wrapper image_flex_image--wrap" v-if="config">
    <div class="plugin-image_flex_image layout">
      <div class="item-block">
        <div class="item-block__title heading-h3">{{config.title}}</div>
        <div class="item-block__tile">
          <div class="product">
            <div class="item-standard item-tile item-wrapper">
              <div class="image-container item-tile__image-container" v-if="config.src && config.src.pc">
                <template v-if="config.src.h5">
                  <img class="tile-image item-tile__image show-for-md lazyloaded" :alt="config.title" :src="config.src.pc" />
                  <img class="tile-image item-tile__image hide-for-md lazyloaded" :alt="config.title" :src="config.src.h5" />
                </template>
                <template v-else>
                  <img class="tile-image item-tile__image lazyloaded" :alt="config.title" :src="config.src.pc" />
                </template>
              </div>
              <div class="item-tile__badges" v-if="config.bagges">
                <div class="item-tile__badge">
                  <span class="item-tile__badge-item" style="background-color: #fff; color: #000000; border-color: #CACACA">新品上市</span>
                </div>
              </div>
              <div class="tile-body item-tile__body">
                <h3 class="pdp-link item-tile__name item-tile__name-link">{{config.text1}}</h3>
                <p class="item-tile__description text--no-margin">{{config.text2}}</p>
                <div class="tile-body-footer item-tile__tile-body-footer clearfix" v-if="config.lowest_price">
                  <div class="item-tile__price-container">
                    <div class="price item-tile__price">
                      <div>
                        <!-- <div class="strike-through list item-tile__price--strike-through btn--bold " v-if="config.lowest_ori_price && config.lowest_ori_price != config.lowest_price">
                          <p class="text--no-margin">
                            <span class="sr-only">原价</span>
                            <span class="value">￥ {{config.lowest_ori_price}}</span>
                          </p>
                        </div> -->
                        <div class="sales item-tile__price-sales btn--bold">
                          <p class="text--no-margin">
                            <span class="sr-only">售价</span>
                            <span class="value">￥ {{config.lowest_price}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item-tile__actions-wrapper">
                  <a class="btn btn--primary" href="javascript:void(0);" @click="actionHandler(config.action)">{{config.button}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actionMixins from "@/utils/action.mixins";

export default {
  name: "ImageFlexImage",
  mixins: [actionMixins],
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .item-block { position: relative; margin: 0 auto; text-align: center; }
  .item-tile__name { color: #000; margin-top: .3125rem; overflow: hidden; text-transform: none; }
  .item-tile__name-link {
    font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; font-size: .8125rem; color: #000;
    line-height: 1.3; text-decoration: none; letter-spacing: normal; margin-bottom: 0;
    &:after { content: ""; position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 1; }
  }
  .item-tile__description { font-size: .75rem; height: 2.25rem; overflow: hidden; color: #575757; }
  .item-tile__tile-body-footer { max-height: 2.5rem; margin-top: .625rem; }
  .item-tile__actions-wrapper { margin-top: .9375rem; position: relative; z-index: 2; }
  .item-tile__price-container { font-size: .75rem; font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; white-space: nowrap; }
  .item-tile__price { margin-right: .625rem; }
  .item-tile__price--strike-through { margin-right: .625rem; color: #575757; text-decoration: line-through; display: inline-block; }
  .item-tile__price-sales { color: #000; display: inline-block; }
  .plugin-image_flex_image {
    .item-block {
      padding: 0 0 2.1875rem;
      .item-block__title {
        font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; color: #000; font-size: 3.125rem; line-height: 1;
        position: absolute; top: 0; left: 0; right: 0; z-index: 1; text-align: center;
      }
      .item-block__tile {
        padding-top: .625rem;
        .item-tile {
          position: relative; max-width: 100%; display: flex; flex-direction: column;
          .item-tile__image-container { order: 1; }
          .item-tile__image { width: 100%; }
          .item-tile__badges {
            position: absolute; left: .625rem; top: .625rem; text-align: left; z-index: -1; order: -1; display: none;
            .item-tile__badge {
              font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; font-size: .625rem;
              text-transform: uppercase; letter-spacing: .0625rem; margin-bottom: .3125rem;
              .item-tile__badge-item { border: .0625rem solid #8c8c8c; background-color: transparent; padding: .125rem .3125rem; color: #575757; display: inline; }
            }
          }
          .item-tile__body {
            text-align: left; position: relative; margin: 0 auto; max-width: 18.75rem; order: 3;
            .item-tile__name { height: auto; overflow: visible; }
            .item-tile__name-link { font-size: 1rem; }
            .item-tile__description { font-size: .8125rem; height: auto; overflow: visible; }
            .item-tile__tile-body-footer { height: auto; }
          }
        }
      }
    }
  }
  @media screen and (min-width: 48em) {
    .item-tile__name { margin-top: .75rem; }
    .item-tile__name-link { font-size: 1rem; }
    .item-tile__description { font-size: .8125rem; height: 1.25rem; }
    .item-tile__tile-body-footer { max-height: none; height: 1.25rem; margin-top: .625rem; }
    .item-tile__actions-wrapper { margin-top: 1.25rem; }
    .item-tile__price-container { float: left; margin-right: .625rem; }
    .plugin-image_flex_image {
      .item-block {
        padding: 0 3.875rem 2.5rem; margin-top: 2.1875rem;
        .item-block__title { font-size: 4.375rem; }
        .item-block__tile {
          padding-top: 0;
          .item-tile {
            position: relative; max-width: 100%;
            .item-tile__body {
              margin: 0; text-align: left; position: absolute; left: 0; top: 6.25rem; max-width: 13.125rem;
              .item-tile__price-container { float: none; margin-right: 0; }
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 64em) {
    .item-tile__description { height: 1.125rem; }
    .plugin-image_flex_image {
      .item-block {
        padding: 0 1.875rem 2.5rem; margin-top: .9375rem;
        .item-block__title { font-size: 7.5rem; }
        .item-block__tile {
          padding-top: .9375rem;
          .item-tile {
            max-width: 100%; margin: 0 auto;
            .item-tile__body {
              left: 3.125rem; top: 9.6875rem;
              .item-tile__price-container { float: left; margin-right: .625rem; }
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-image_flex_image {
      .item-block {
        padding: 0 0 3.125rem; margin-top: 1.875rem;
        .item-block__title { font-size: 11.25rem; }
        .item-block__tile {
          padding-top: 1.5625rem;
          .item-tile {
            .item-tile__body {
              left: 6.25rem; top: 13.125rem;
            }
          }
        }
      }
    }
  }
</style>